var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-header-page"},[_c('div',{staticClass:"dashboard-title"},[(_vm.icon)?_c('i',{staticClass:"mr-2",class:_vm.icon}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.subTitle)?_c('div',{staticClass:"dashboard-subtitle"},[_vm._v("\n        "+_vm._s(_vm.subTitle)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1e6292e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Base/PageHeader.vue
// module id = null
// module chunks = 